module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset>\n  <div class="phx-formTable">\n    <div>\n      <span class="NDemandes"></span><br/>\n      <span class="NDemandesAbandone"></span><br/>\n      <span class="NDemandesError"></span>\n    </div>\n  </div>\n</fieldset>';
}
return __p;
};
